/**
 * Hook that fires APP_OPENED once per browser session.
 *
 * Uses sessionStorage to deduplicate — the flag is cleared when the
 * browser tab/window closes, so the next visit fires again.
 */

import { useEffect } from 'react';
import { Events } from '@danny-tasks/shared/telemetry';
import { useTrackEvent } from './hooks';

const SESSION_KEY = 'danny_app_opened';

export function useAppOpened(): void {
  const track = useTrackEvent();

  useEffect(() => {
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');
    track(Events.APP_OPENED, {});
  }, [track]);
}
